import { Deck, DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { DeckGroup } from "@ponder-features/user/decks/deck/group/deck-group";
import { environment } from "../../../../../environments/environment";

export class MagicDeckGroupSorceries extends DeckGroup {
    public constructor() {
        super("Sorceries", `${environment.ponderImageBaseUrl}/magic/set/tmp.svg`);
    }
    
    public override isValid(deck: Deck, card: DeckCard): boolean {
        if (card.card.item.data?.magic) {
            var frontFace = card.card.item.data.magic.faces![0];

            if (frontFace.typeLine?.includes("Sorcery")) {
                return true;
            }
        }

        return false;
    }
}